import type { ReactNode } from "react";

import styles from "./state-message.module.scss";

interface StateMessageProps {
  icon: string;
  title: string;
  description?: string;
  testId: string;
  children?: ReactNode;
}

/** Bloco de carregando / vazio / erro / acesso não autorizado das telas do Painel de Controle. */
export function StateMessage({ icon, title, description, testId, children }: StateMessageProps) {
  return (
    <div className={styles.stateMessage} role="status" data-testid={testId}>
      <i className={`${icon} ${styles.stateIcon}`} aria-hidden />
      <p className={styles.stateTitle}>{title}</p>
      {description ? <p className={styles.stateDescription}>{description}</p> : null}
      {children}
    </div>
  );
}
